import React from "react";
import { bgClassName } from "../../../utils/bgClass";
import { ArrowDown, ArrowUp } from "../../../assets/icons";
import { formatMoney, useGetPaymentCurrencyList } from "../../../utils";
import { formatDate } from "../../../utils/formatDate";
import { useNavigate } from "react-router-dom";
import { TransactionDataType } from "../../../@types";
import { InvoiceUp } from "../../../assets/icons/invoiceUp";
import { ExpenseDown } from "../../../assets/icons/expenseDown";
import { useCompanyStore } from "../../../state/useCompanyStore";

interface TransactionItemProps {
  data: TransactionDataType;
}

const tags: any = {
  paid: {
    text: "#039855",
    bg: "#ECFDF3",
  },
  expired: {
    text: "#044E97",
    bg: "#FFFAEB",
  },
  pending: {
    text: "#DC6803",
    bg: "#FFFAEB",
  },
  due: {
    text: "#D92D20",
    bg: "#FEF3F2",
  },
  draft: {
    text: "#03B8DC",
    bg: "#EBFCFF",
  },
  canceled: {
    text: "#475467",
    bg: "#F9FAFB",
  },
  refunded: {
    text: "#044E97",
    bg: "#E0EEFE",
  },
};

const TransactionItem = ({ data }: TransactionItemProps) => {
  const navigate = useNavigate();
  const companyProfile = useCompanyStore();
  const { userCurrencyCode } = useGetPaymentCurrencyList(
    companyProfile.company,
  );

  const handleNavigate = (data: any) => {
    if (data.type === "invoice") {
      navigate(`/invoices/${data.id}/view`);
    } else {
      navigate(`/expenses/${data.id}/view`);
    }
  };

  return (
    <div
      onClick={() => handleNavigate(data)}
      className="flex justify-between items-center py-2 cursor-pointer hover:bg-gray-100"
    >
      <div className="flex items-center gap-2">
        <div className={bgClassName(data.type)}>
          {data.type === "invoice" ? (
            <div data-testid="arrow-up">
              <InvoiceUp />
            </div>
          ) : (
            <div data-testid="arrow-down">
              <ExpenseDown />
            </div>
          )}
        </div>
        <div className="text-[#000] text-[14px] font-medium leading-5">
          <p>
            {data.type === "invoice" ? (
              <p className="flex items-center space-x-2">
                <span>
                  {data?.customer?.firstName || ""}{" "}
                  {data?.customer?.lastName || ""}
                </span>
                <span
                  className={`hidden px-1.5 py-1 rounded-[4px] text-[13px] font-medium capitalize justify-center bg-[${tags[data?.status!]?.bg}] text-[${tags[data?.status!]?.text}]`}
                >
                  {data?.status}
                </span>
              </p>
            ) : (
              <span>{data.name || data.category}</span>
            )}
          </p>
          <p className="text-[12px] text-[#475467] leading-4 mt-[2px]">
            {data.type === "invoice"
              ? formatDate(data?.issueDate || "")
              : formatDate(data?.date || "")}
          </p>
        </div>
      </div>

      <div className="text-[#000] font-semibold leading-6">
        {data.type === "invoice" ? (
          <div className="flex flex-col">
            <span>{formatMoney(data.total, data?.currency)}</span>
            <span
              className={`flex text-[13px] font-semibold capitalize justify-end text-[${tags[data?.status!]?.text}]`}
            >
              {data?.status}
            </span>
          </div>
        ) : (
          <span>{formatMoney(data.amount, userCurrencyCode?.currency)}</span>
        )}
      </div>
    </div>
  );
};

export default TransactionItem;
